/**
 * Removes text in parentheses from a language name
 * Example: "English (UK)" -> "English"
 */
export const cleanLanguageName = (name?: string): string | undefined => {
  if (name === undefined) return;

  const openBracketIndex = name.indexOf('(');

  if (openBracketIndex === -1) return name;
  return name.substring(0, openBracketIndex).trim();
};

export default cleanLanguageName;
